import { render, staticRenderFns } from "./currencyDetail.vue?vue&type=template&id=54e316a5&"
import script from "./currencyDetail.vue?vue&type=script&lang=js&"
export * from "./currencyDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54e316a5')) {
      api.createRecord('54e316a5', component.options)
    } else {
      api.reload('54e316a5', component.options)
    }
    module.hot.accept("./currencyDetail.vue?vue&type=template&id=54e316a5&", function () {
      api.rerender('54e316a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configure/currencyDetail.vue"
export default component.exports